module.exports = __webpack_public_path__ + "img/dial1.6205710f.png";